import { getBillingManualOtherDeductions } from 'utils/otherDeductionColumns'

export function computeBillingFigures(billingDetails = {}, vat_from = 'admin_cost') {
    if (!billingDetails) return billingDetails

    const computed = { ...billingDetails }
    const toFiniteNumber = (value) => {
        const number = Number(value)
        return Number.isFinite(number) ? number : 0
    }
    const manualOtherDeductions = getBillingManualOtherDeductions(computed)
    computed.gross_billing = toFiniteNumber(computed.gross_billing)
    computed.rebate = Math.max(0, toFiniteNumber(computed.rebate))
    computed.salary_deduction = toFiniteNumber(computed.salary_deduction)
    computed.meal_allowance = toFiniteNumber(computed.meal_allowance)


    computed.admin_cost = computed.gross_billing * 0.1 //10 percent admin cost


    if (vat_from === 'admin_cost') {

        const taxableBase = Math.max(0, computed.admin_cost - computed.rebate)
        computed.vat = taxableBase * 0.12 //12 percent vat
        computed.withholding_tax = taxableBase * 0.02 //2 percent withholding tax
    }
    else if (vat_from === 'gross_billing_admin_cost') {
        let grossBillingPlusAdminCost = Math.max(0, computed.gross_billing + computed.admin_cost - computed.rebate)
        computed.vat = grossBillingPlusAdminCost * 0.12 //12 percent vat
        computed.withholding_tax = grossBillingPlusAdminCost * 0.02 //2 percent withholding tax
    }
    else if (vat_from === 'gross_billing') {
        const taxableBase = Math.max(0, computed.gross_billing - computed.rebate)
        computed.vat = taxableBase * 0.12 //12 percent vat
        computed.withholding_tax = taxableBase * 0.02 //2 percent withholding tax
    }
    else {
        const taxableBase = Math.max(0, computed.admin_cost - computed.rebate)
        computed.vat = taxableBase * 0.12 //12 percent vat
        computed.withholding_tax = taxableBase * 0.02 //2 percent withholding tax
    }


    /*
    console.log('admin cost', billingDetails.admin_cost)
    console.log('vat', billingDetails.vat)
    console.log('withholding tax', billingDetails.withholding_tax)
    */
    let sumBilling = computed.gross_billing + computed.admin_cost - computed.rebate
    let totalBilling = sumBilling + computed.vat - computed.withholding_tax
    let netBilling = totalBilling - (computed.salary_deduction + computed.meal_allowance + manualOtherDeductions)

    /*
    console.log('sum billing', billingDetails.gross_billing, '+', billingDetails.admin_cost, '-', billingDetails.rebate, '=', sumBilling)
    console.log('total billing', totalBilling)
    console.log('net billing', netBilling)
    */

    computed.sum_billing = sumBilling
    computed.total_billing = totalBilling
    computed.net_billing = netBilling
    computed.other_deductions = manualOtherDeductions

    return computed
}

export function generateGrossBillingForThisCutoff(payrollEntries = []) {
    if (!payrollEntries || payrollEntries.length === 0) return 0

    let grossBilling = 0
    payrollEntries.forEach(entry => {
        grossBilling += entry.gross_billing || 0
    })

    return grossBilling
}

export default {
    computeBillingFigures,
    generateGrossBillingForThisCutoff
}
